module.exports = __webpack_public_path__ + "static/img/bg-top.96fe05fb.png";